import React, { FC } from 'react';
import CertificateIcon from 'src/assets/icons/CertificateIcon';
import PercentIcon from 'src/assets/icons/PercentIcon';
import ConsultIcon from 'src/assets/icons/ConsultIcon';
import DownloadIcon from 'src/assets/icons/DownloadIcon';
import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import { rem } from 'polished';
import { gutter, halfGutter } from 'src/config/layout';
import { typography } from 'src/config/typography';
import { SectionTitle } from 'src/common/components/SectionTitle';
import { media } from 'src/config/breakpoints';
import { StyleProps } from 'src/lib/styleProps';

const Footer = styled.div`
  background: ${colors.grey05};
  margin: 0 -${rem(halfGutter)};
  padding: 2rem 9vw 0.625rem;
  text-align: center;

  ${media.w.min.px768(css`
    margin: 0 -${rem(gutter)};
    padding: 3.25rem 2.1875rem 4.1875rem;
  `)};

  ${media.w.min.px992(css`
    padding-bottom: 2.1875rem;
    padding-top: 2.25rem;
  `)};

  ${media.w.min.px1200(css`
    padding-bottom: 3.25rem;
    padding-top: 4.1875rem;
  `)};
`;

const FooterItem = styled.div`
  align-items: center;
  display: flex;
  font-family: ${typography.fontFamilyHeaders};
  font-size: 0.625rem;
  margin-bottom: 2.25rem;
  padding: 0 2.5vw;
  text-align: left;
  width: 50%;

  ${media.w.min.px768(css`
    margin-bottom: 0;
    padding: 0 0.75rem;
    width: auto;
  `)};

  ${media.w.min.px1200(css`
    padding: 0 1.1875rem;
  `)};

  svg {
    flex: 0 0 auto;
  }
`;

const FooterItems = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 1.375rem -2.5vw 0;

  ${media.w.min.px768(css`
    flex-wrap: nowrap;
    margin: 1.4375rem -2.1875rem 0;
  `)};

  ${media.w.min.px1200(css`
    margin-left: -1.1875rem;
    margin-right: -1.1875rem;
  `)};
`;

const FooterText = styled.div`
  margin-left: 0.875rem;
`;

export const CourseFooter: FC<StyleProps> = ({ className }) => (
  <Footer className={className}>
    <SectionTitle>Dodatkowe korzyści</SectionTitle>

    <FooterItems>
      <FooterItem>
        <CertificateIcon size={24} />
        <FooterText>Odbierz certyfikat uczestnictwa w&nbsp;szkoleniu</FooterText>
      </FooterItem>

      <FooterItem>
        <PercentIcon size={22} />
        <FooterText>Bierz bezpłatny udział dzięki 100% dofinansowaniu</FooterText>
      </FooterItem>

      <FooterItem>
        <ConsultIcon size={24} />
        <FooterText>Konsultuj swoje wyzwania biznesowe z&nbsp;prowadzącym</FooterText>
      </FooterItem>

      <FooterItem>
        <DownloadIcon size={24} />
        <FooterText>Pobieraj materiały pomocnie tj. wzory i&nbsp;dokumenty</FooterText>
      </FooterItem>
    </FooterItems>
  </Footer>
);
